module.exports = __webpack_public_path__ + "img/7.44e4a4fa.png";